module.exports = __webpack_public_path__ + "img/team_4.d3593e85.jpg";